<template>
  <div class="other-resource-list-container">
    <div class="jc-page-top">
      <div class="instance-list">
        <div class="jc-page-header">
          <h1><i class="jc-icon-my-circle-bold"></i>{{ $t("otherResource.title") }}</h1>
          <div class="jc-box-action"></div>
        </div>
        <div class="jc-page-content">
          <!-- SearchListPane组件 -->
          <SearchListPane
            ref="searchPane"
            :search-configs="searchConfigs"
            :search-form-data="searchForm"
            @search="handleSearch"
            @reset="handleReset"
            :default-visible-count="3"
            :show-collapse-button="true"
          />
          <div class="el-container-table common-table-container">
            <!-- 表头操作 -->
            <div class="el-container-table-actionBar">
              <el-form class="el-table-actionBar-item" :inline="true">
                <el-form-item>
                  <el-button
                    icon="jc-icon-refresh-line"
                    class="el-button-icon"
                    @click="updateList"
                    :disabled="refreshloading"
                  ></el-button>
                </el-form-item>
              </el-form>
              <el-form class="el-box-table-search" :inline="true" @submit.native.prevent>
                <!-- 标签过滤器（暂时注释，专线可能不需要标签功能）-->
                <el-form-item class="set-icon">
                  <jcb-tag-filter
                    :service-code="ServiceCodeConstant.CCS"
                    :visible.sync="batchEditTagDialogVisible"
                    :region-id="TagRegionID"
                    @checkedTags="filterWithCheckedTags"
                  >
                  </jcb-tag-filter>
                </el-form-item>

                <el-form-item class="set-icon">
                  <el-button
                    icon="el-icon-setting"
                    class="el-button-icon"
                    @click="setCustom"
                    :title="$t('merge.customList')"
                  ></el-button>
                </el-form-item>
                <el-form-item>
                  <el-button
                    icon="jc-icon-download"
                    class="el-button-icon"
                    @click="exportList"
                    :title="$t('speechcraft.exportResourceList')"
                  ></el-button>
                </el-form-item>
              </el-form>
            </div>
            <!-- 表格 -->
            <div class="el-container-table">
              <el-table
                :data="tableData"
                tooltip-effect="light"
                ref="table"
                v-loading="refreshloading"
                :empty-text="tableEmptyTip"
                @selection-change="handleSelectionChange"
              >
                <!-- 复选框列 -->
                <el-table-column
                  type="selection"
                  width="55"
                  v-if="customInfo !== null">
                </el-table-column>
                
                <!-- ID -->
                <el-table-column
                  prop="otherResourceId"
                  key="otherResourceId"
                  min-width="130"
                  :label="$t('otherResource.id')"
                  fixed
                  v-if="getCustomInfoSelect('otherResourceId')"
                >
                  <template slot-scope="scope">
                    <span>{{ scope.row.otherResourceId | maybeEmpty }}</span>
                  </template>
                </el-table-column>
                <!-- 资源名称 -->
                <el-table-column
                  prop="otherResourceName"
                  key="otherResourceName"
                  min-width="150"
                  :label="$t('otherResource.name')"
                  fixed
                  v-if="getCustomInfoSelect('otherResourceName')"
                >
                  <template slot-scope="scope">
                    <span>{{ scope.row.otherResourceName | maybeEmpty  }}</span>
                  </template>
                </el-table-column>
                <!-- 机房名称 -->
                <el-table-column
                  prop="datacenterNameShow"
                  key="datacenterNameShow"
                  min-width="150"
                  :label="$t('otherResource.idcName')"
                  v-if="getCustomInfoSelect('datacenterNameShow')"
                >
                  <template slot-scope="scope">
                    <span>{{ scope.row.datacenterNameShow | maybeEmpty  }}</span>
                  </template>
                </el-table-column>
                <!-- 托管区 -->
                <el-table-column
                  prop="regionShow"
                  key="regionShow"
                  min-width="120"
                  :label="$t('otherResource.region')"
                  v-if="getCustomInfoSelect('regionShow')"
                >
                  <template slot-scope="scope">
                    <span>{{ scope.row.regionShow | maybeEmpty  }}</span>
                  </template>
                </el-table-column>
                <!-- 资源类型 -->
                <el-table-column
                  prop="productTypeName"
                  key="productTypeName"
                  min-width="120"
                  :label="$t('otherResource.resourceType')"
                  v-if="getCustomInfoSelect('productTypeName')"
                >
                  <template slot-scope="scope">
                    <span>{{ scope.row.productTypeName | maybeEmpty  }}</span>
                  </template>
                </el-table-column>
                <!-- 资源用量 -->
                <el-table-column
                  prop="resourceUsage"
                  key="resourceUsage"
                  min-width="120"
                  :label="$t('otherResource.resourceUsage')"
                  v-if="getCustomInfoSelect('resourceUsage')"
                >
                  <template slot-scope="scope">
                    <span>{{ scope.row.resourceUsage | maybeEmpty  }}</span>
                  </template>
                </el-table-column>
                <!-- 计费信息 -->
                <el-table-column
                  key="billingInfo"
                  min-width="180"
                  :label="$t('otherResource.billingInfo')"
                  v-if="getCustomInfoSelect('billingInfo')"
                >
                  <template slot-scope="scope">
                    <div>
                      {{ $t("directConnects.billingTime") }}: {{ scope.row.startTime | maybeEmpty }}
                    </div>
                    <div>
                      {{ $t("directConnects.expireTime") }}: {{ scope.row.endTime | maybeEmpty }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column 
                    :label="$t('text.tags')"
                    key="tags"
                    v-if="getCustomInfoSelect('tags')"
                    min-width="120"
                    class-name="p-line-break">
                  <template slot-scope="scope">
                    <p>{{scope.row.tagPairs | maybeEmpty}}</p>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
        <custom
          :visible.sync="customVisible"
          v-if="customVisible"
          :optionArr="optionArr"
          :type="type"
        ></custom>
      </div>
    </div>
    <div
      class="el-page-footer block el-container-table-actionBar"
      v-if="tableData.length"
    >
      <div class="el-page-footer__actions">
        <el-tooltip
          class="item"
          effect="dark"
          :content="$t('text.pleaseSelectResource')"
          :disabled="!!multipleSelection.length"
          :visible-arrow="false"
          placement="top"
        >
          <el-button
            type="primary"
            :disabled="!multipleSelection.length"
            @click="batchEditTag"
          >
            {{$t('text.editTag')}}
          </el-button>
        </el-tooltip>
      </div>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="pageSizeArr"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>

    <!--编辑标签-->
    <jcb-tag-edit
      :visible.sync="editTagDialogVisible"
      :service-code="ServiceCodeConstant.CCS"
      :region-id="TagRegionID"
      :resource-ids="resourceId"
      @complete="updateList"
    >
    </jcb-tag-edit>
  </div>
</template>

<script>
import { cloneDeep } from "lodash";
import custom from "../common/custom/Custom.vue";
import SearchListPane from "../common/search/SearchListPane.vue";
import searchOperate from "@/mixins/searchOperate";
import { ServiceCodeConstant } from "@/common/Constants";
import customInfo from "../../store/modules/customInfo";
import customInfoSelect from "@/mixins/customInfoSelect";

export default {
  name: "OtherResourceList",
  components: {
    custom,
    SearchListPane,
  },
  mixins: [searchOperate, customInfoSelect],
  data() {
    return {
      refreshloading: false,
      tableData: [],
      tableEmptyTip: "",
      tableEmptyMap: {
        noSearch: this.$t("text.noSearch"),
        hasSearch: this.$t("text.hasSearch"),
      },
      customVisible: false,
      type: 'otherResource',
      // 分页相关数据
      currentPage: 1, // 当前页数
      pageSize: 20, // 当前显示数据个数
      pageSizeArr: [20, 50, 100], // 每页显示总数
      total: 0, // 数据总数

      // SearchListPane配置
      searchConfigs: [
        {
          field: "otherResourceName",
          type: "input",
          label: this.$t("otherResource.name"),
          placeholder: this.$t("placeholder.placeholderInput", [this.$t("otherResource.name")]),
        },
        {
          field: "datacenterName",
          type: "multiple-select",
          label: this.$t("otherResource.idcName"),
          placeholder: this.$t("placeholder.placeholderSelectMore", [this.$t("otherResource.idcName")]),
          options: [],
        },
        {
          field: "otherResourceId",
          type: "input",
          label: this.$t("otherResource.id"),
          placeholder: this.$t("placeholder.placeholderInputMore", [this.$t("otherResource.id")]),
        },
        {
          field: "regionEn",
          type: "multiple-select",
          label: this.$t("otherResource.region"),
          placeholder: this.$t("placeholder.placeholderSelectMore", [this.$t("otherResource.region")]),
          options: [],
        },
        {
          field: "productType",
          type: "multiple-select",
          label: this.$t("otherResource.resourceType"),
          placeholder: this.$t("placeholder.placeholderSelectMore", [this.$t("otherResource.resourceType")]),
          options: [],
        },
      ],
      searchForm: {
        otherResourceName: "", // 资源名称
        otherResourceId: "", // ID
        datacenterName: [], // 机房名称
        regionEn: [], // 托管区
        productType: [], // 资源类型
      },

      // 自定义列选项
      optionArr: [
        { label: this.$t("otherResource.id"), value: "otherResourceId" },
        { label: this.$t("otherResource.name"), value: "otherResourceName" },
        { label: this.$t("otherResource.idcName"), value: "datacenterNameShow" },
        { label: this.$t("otherResource.region"), value: "regionShow" },
        { label: this.$t("otherResource.resourceType"), value: "productTypeName" },
        { label: this.$t("otherResource.resourceUsage"), value: "resourceUsage" },
        { label: this.$t("otherResource.billingInfo"), value: "billingInfo" },
        { label: this.$t('text.tags'), value: 'tags' },
      ],
      // 编辑标签组件是否显示
      editTagDialogVisible: false,
      // 批量编辑标签组件是否显示
      batchEditTagDialogVisible: true,
      resourceId: [],
      // 标签过滤后的资源ID
      filteredResourceIds: [],
      multipleSelection: [],
      filtersValue: {
        productType: [],
      }
    };
  },
  computed: {
    ServiceCodeConstant: () => ServiceCodeConstant,
    // vuex中获取自定义信息
    customInfo() {
      return this.$store.state.customInfo[this.type];
    },
    filterList () {
      return this.$store.state.filter.filterList;
    },
  },
  created() {
    const {productType} = this.$route.query || {};
    if (productType) {
      this.filtersValue.productType.push(productType)
    }
    this.updateList();
    if (!this.$store.state.customInfo[this.type]) {
      this.getCustomInfo();
    }
    this.getDatacenterName();
  },
  methods: {
    getDatacenterName() {
      this.$api.getRegions({ all: 1 }).then((res) => {
        if (res.errno === 10000 && res.data && res.data.idcs) {
          this.fliter_region = res.data.idcs.map(item => ({
            datacenterNameParam: item.datacenterNameParam,
            datacenterNameShow: item.datacenterNameShow,
            regionShow: item.regionShow,
            regionEn: item.regionEn
          }));
          this.initSearchOptions();
        } else {
          this.fliter_region = [];
        }
      }).catch(() => {
        this.fliter_region = [];
      });
    },
    initSearchOptions() {
      const idcOptions = (this.fliter_region || []).map(region => ({
        value: region.datacenterNameParam,
        label: region.datacenterNameShow
      }));
      const regionOptions = (this.fliter_region || []).map(region => ({
        value: region.regionEn,
        label: region.regionShow
      }));
      const productTypeOptions = (this.filterList && this.filterList.otherResourceProductType) ? [...this.filterList.otherResourceProductType] : [];

      this.searchConfigs = this.searchConfigs.map(config => {
        if (config.field === 'datacenterName') {
          return { ...config, options: idcOptions };
        }
        if (config.field === 'regionEn') {
          return { ...config, options: regionOptions };
        }
        if (config.field === 'productType') {
          return { ...config, options: productTypeOptions };
        }
        return config;
      });
    },
    // 分页大小改变
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.updateList();
    },
    // 当前页码改变
    handleCurrentChange(val) {
      this.currentPage = val;
      this.updateList();
    },
    async updateList() {
      this.refreshloading = true;
      try {
        const params = {
          pageNumber: this.currentPage,
          pageSize: this.pageSize,
        };

        // 处理搜索参数
        for (const key in this.searchForm) {
          const value = this.searchForm[key];
          if (Array.isArray(value)) {
            if (value.length > 0) {
              params[key] = value.join(',');
            }
          } else if (typeof value === 'string') {
            const trimmedValue = value.trim();
            if (trimmedValue) {
              params[key] = trimmedValue;
            }
          }
        }

        Object.keys(this.filtersValue).forEach((key) => {
          if (this.filtersValue[key].length > 0) {
            params[key] = this.filtersValue[key][0];
          }
        });

        // 标签过滤
        if (this.filteredResourceIds.length) {
          params.otherResourceId = this.filteredResourceIds.join(' ');
        }

        const res = await this.$api.describeResourceOtherResources(params);
        if (res.errno === 10000 && res.data) {
          const { otherResources, totalCount } = res.data;
          this.tableData = otherResources || [];
          this.total = totalCount || 0;
          this.tableData.forEach((item) => {
            item.tagPairs = '';
            if (item.tags !== undefined && item.tags.length > 0) {
              item.tags.forEach((tag) => {
                item.tagPairs += `${tag.key}:${tag.value},`;
              });
              item.tagPairs = item.tagPairs.substring(0, item.tagPairs.length - 1);
            }
          });
        } else {
          this.tableData = [];
          this.total = 0;
          this.$message.error(res.errmsg || '获取数据失败');
        }
      } catch (e) {
        this.tableData = [];
        this.total = 0;
        this.tableEmptyTip = this.tableEmptyMap.noSearch;
      } finally {
        this.refreshloading = false;
      }
    },


    setCustom() {
      this.customVisible = true;
    },

    batchEditTag() {
      this.resourceId = (this.multipleSelection || []).map(item => item.otherResourceId || item.id).filter(Boolean);
      if (!this.resourceId.length) {
        return;
      }
      this.editTagDialogVisible = true;
    },

    handleSelectionChange(val) {
      this.multipleSelection = val || [];
    },

    /**
     **@disc: 根据标签对实例进行过滤
     */
    filterWithCheckedTags(filterTags, tagKeys, resourceIds) {
      if (tagKeys.length !== 0) {
        this.filteredResourceIds = resourceIds;
      } else {
        this.filteredResourceIds = [];
      }
      this.updateList();
    },

    // 获取自定义信息
    getCustomInfo() {
      const param = {
        pageKey: this.type,
      };
      this.$api.getCustomInfo(param).then((res) => {
        if (res.errno === 10000 && res.data.customInfo) {
          this.$store.commit("GET_CUSTOMINFO", {
            value: res.data.customInfo,
            type: this.type,
          });
        }
      });
    },

    exportList() {
      const params = [];
      for (const key in this.searchForm) {
        const value = this.searchForm[key];
        if (Array.isArray(value)) {
          if (value.length > 0) {
            params.push(`${key}=${value.join(',')}`);
          }
        } else if (typeof value === 'string') {
          const trimmedValue = value.trim();
          if (trimmedValue) {
            params.push(`${key}=${trimmedValue}`);
          }
        }
      }
      if (this.filteredResourceIds.length) {
        params.push(`otherResourceId=${this.filteredResourceIds.join(' ')}`);
      }

      let url = '/ccs-api/api/resource/exportOtherResources?all=1';
      if (params.length > 0) {
        url += '&' + params.join('&');
      }
      Object.keys(this.filtersValue).forEach((key) => {
        if (this.filtersValue[key].length > 0) {
          url += `&${key}=${encodeURIComponent(this.filtersValue[key][0])}`;
        }
      });
      window.open(url, '_self');
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./list.scss";
</style>



// WEBPACK FOOTER //
// src/components/otherResource/OtherResourceList.vue